/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-07-25 15:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { FieldArray } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ListCustomSorting from './list-custom-sorting';

type Props = {
  handleChange: () => void
};

type ComposedProps = Props & WithI18nProps;

class SortByOptionsTab extends Component<ComposedProps> {
  render() {
    const {
      loading,
      sortOptions,
      success,
      sortTypes,
      updatePositionFlag,
      updateCustomSortingForm,
      enabledFeatureBestSelling,
      enabledFeatureManual,
      enabledFeatureRelevance,
      defaultSorting
    } = this.props;

    return (
      <FieldArray
        name="sortOptions"
        component={ListCustomSorting}
        key={'list-custom-sorting'}
        loading={loading}
        sortOptions={sortOptions}
        success={success}
        sortTypes={sortTypes}
        enabledFeatureBestSelling={enabledFeatureBestSelling}
        enabledFeatureManual={enabledFeatureManual}
        enabledFeatureRelevance={enabledFeatureRelevance}
        updatePositionFlag={updatePositionFlag}
        updateCustomSortingForm={updateCustomSortingForm}
        defaultSorting={defaultSorting}
      />
    );
  }
}

export default withI18n()(SortByOptionsTab);
